const trackUtils = require('./trackUtils');


/** exclude back view */
if ((history.state === null || typeof history.state.lastSectionView === 'undefined') || (typeof history.state.lastSectionView === 'string' && history.state.lastSectionView === 'main')) {

  try {

    let tracking = window.vocento.tracking;

    TagManager.ready.then(function () {


      /** default values set ******************************************************************************************/
      TagManager.set({
        seccion: tracking.comscore.voc_se,
        subseccion1: tracking.comscore.voc_s1,
        subseccion2: tracking.comscore.voc_s2,
        subseccion3: tracking.comscore.voc_s3,
        subseccion4: tracking.comscore.voc_s4,
        titular: tracking.comscore.voc_tn,
        tipoDominio: tracking.comscore.voc_pr,
        edicion: tracking.comscore.voc_ed,
        tipoContenido: tracking.comscore.voc_tc,
        tipoContenidoA: tracking.comscore.voc_tcnew,
        plataformaContenido: tracking.comscore.voc_pl,
        sistemaPublicacion: tracking.comscore.voc_pu,
        fechaPrimeraPublicacion: tracking.comscore.voc_fep,
        fechaModificacion: tracking.comscore.voc_fem,
        idioma: tracking.comscore.voc_idi,
        IDEvolok: tracking.comscore.voc_pw_pid,
        firmaAutor: tracking.comscore.voc_au,
        origenContenido: tracking.comscore.voc_or,
        topics: tracking.comscore.voc_top
      });

      /** only home or home section sets ******************************************************************************/
      if (tracking.comscore.voc_tc === 'portada' || tracking.comscore.voc_tc === 'portadilla') {

        /** scrollInfinito & scrollInfinitoHome */
        if (tracking.comscore.voc_tc === 'portada') {
          TagManager.set({scrollInfinito: true});
          TagManager.set({scrollInfinitoHome: 1});
        }

      /** only news sets **********************************************************************************************/
      } else {

        /** news defaults */
        TagManager.set({
          slot:'',
          modulosRotacion:tracking.comscore.modulosRotacion,
          idNoticia:tracking.comscore.idNoticia
        });

        /** titular */
        if (tracking.comscore.voc_tn.indexOf(".") > -1) {
          TagManager.set({titular:window.voc_tn.substring(0, voc_tn.indexOf("."))});
        } else {
          TagManager.set({titular:tracking.comscore.voc_tn});
        }
      }

      /** error page set **********************************************************************************************/
      if(tracking.root.httpStatus !== '200') {
        TagManager.set({errorPagina: '404'});
      }

      /** updata vocVars */
      window.voc_se        = TagManager.get().seccion;
      window.voc_s1        = TagManager.get().subseccion1;
      window.voc_s2        = TagManager.get().subseccion2;
      window.voc_s3        = TagManager.get().subseccion3;
      window.voc_s4        = TagManager.get().subseccion4;
      window.voc_tn        = TagManager.get().titular;
      window.voc_pr        = TagManager.get().tipoDominio;
      window.voc_ed        = TagManager.get().edicion;
      window.voc_tc        = TagManager.get().tipoContenido;
      window.voc_tcnew     = TagManager.get().tipoContenidoA;
      window.voc_ate       = TagManager.get().contenidoPremium;
      window.voc_pl        = TagManager.get().plataformaContenido;
      window.voc_pu        = TagManager.get().sistemaPublicacion;
      window.voc_fep       = TagManager.get().fechaPrimeraPublicacion;
      window.voc_fem       = TagManager.get().fechaModificacion;
      window.voc_adp       = TagManager.get().movilidad;
      window.voc_ho        = TagManager.get().origenPortada;
      window.voc_idi       = TagManager.get().idioma;
      window.voc_tusr      = TagManager.get().tipologiaLogin;
      window.voc_krux      = TagManager.get().IDKrux;
      window.voc_usrid     = TagManager.get().IDGigya;
      window.voc_usrag     = TagManager.get().edad;
      window.voc_usrcp     = TagManager.get().codigoPostal;
      window.voc_usrgen    = TagManager.get().genero;
      window.customService = TagManager.get().sitioRegistro;
      window.voc_pw_pid    = TagManager.get().IDEvolok;
      window.voc_pw_meter  = TagManager.get().productoEvolok;
      window.voc_pw_count  = TagManager.get().nPaginasConsumidas;
      window.voc_pw_max    = TagManager.get().nPaginasPermitidas;
      window.voc_pw_result = TagManager.get().autorizacionContenido;
      window.voc_pw_cookie = TagManager.get().idCookieEvolok;
      window.voc_adb       = TagManager.get().adBlockers;
      window.voc_adbnew    = TagManager.get().adBlockersNew;
      window.voc_au        = TagManager.get().firmaAutor;
      window.id_autor      = TagManager.get().fichaAutor;
      window.voc_or        = TagManager.get().origenContenido;
      window.voc_top       = TagManager.get().topics;

      TagManager.track();

    }, function (result) {
      trackUtils.imgTrack('vtm-error-promise-result', result);
      console.error(result);
    });
  } catch (ex) {
    trackUtils.imgTrack('vtm-error-exception', ex);
    console.error(ex);
  }
}



// WEBPACK FOOTER //
// ./src/tracking/vtm.js